import React from 'react';
import { Link } from 'react-router-dom';

const PASOS = [
  {
    icono: '🔍',
    titulo: 'Explorá el catálogo',
    texto: 'Navegá todas las propiedades disponibles en Formosa: casas, departamentos, terrenos, locales y más. Todo en un solo lugar, con fotos y detalle completo.',
  },
  {
    icono: '🎯',
    titulo: 'Filtrá lo que buscás',
    texto: 'Usá los filtros para acotar la búsqueda por tipo de propiedad, operación (venta o alquiler), rango de precio, cantidad de dormitorios y ciudad o barrio.',
  },
  {
    icono: '📋',
    titulo: 'Revisá la ficha completa',
    texto: 'Cada propiedad tiene descripción detallada, fotos, ubicación en el mapa y los datos del corredor responsable. Podés consultar por WhatsApp o email desde la misma ficha.',
  },
  {
    icono: '🏠',
    titulo: 'Cerrá con respaldo profesional',
    texto: 'Todos los corredores de FormoProp son miembros matriculados de la Cámara Inmobiliaria de Formosa. Tu operación tiene respaldo legal desde el primer contacto.',
  },
];

export default function ComprarPropiedad() {
  return (
    <div style={{ fontFamily: 'sans-serif' }}>

      {/* ── HERO ── */}
      <div style={{
        background: `linear-gradient(rgba(13,27,42,0.80), rgba(13,27,42,0.90)), url('https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=1920&q=80') center/cover no-repeat`,
        padding: '72px 24px', textAlign: 'center', color: 'white',
      }}>
        <p style={{ margin: '0 0 12px', fontSize: '12px', color: '#60a5fa', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '2px' }}>
          Guía para compradores
        </p>
        <h1 style={{ margin: '0 0 18px', fontSize: '36px', fontWeight: '900', lineHeight: 1.2, maxWidth: '640px', marginLeft: 'auto', marginRight: 'auto' }}>
          Encontrá tu próximo hogar en Formosa
        </h1>
        <p style={{ margin: '0 auto 32px', maxWidth: '540px', color: '#cbd5e1', fontSize: '16px', lineHeight: 1.7 }}>
          Explorá el catálogo completo de propiedades con el respaldo de los corredores matriculados de la Cámara Inmobiliaria de Formosa.
        </p>
        <Link to="/" style={{
          display: 'inline-block', padding: '14px 32px',
          background: '#007bff', color: 'white',
          borderRadius: '8px', textDecoration: 'none',
          fontWeight: '800', fontSize: '15px',
          boxShadow: '0 4px 20px rgba(0,123,255,0.4)',
        }}>
          🔍 Ver el catálogo completo →
        </Link>
      </div>

      {/* ── PASOS ── */}
      <div style={{ background: '#f8fafc', padding: '60px 24px' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <p style={{ textAlign: 'center', margin: '0 0 8px', fontSize: '12px', color: '#007bff', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '2px' }}>
            Paso a paso
          </p>
          <h2 style={{ textAlign: 'center', margin: '0 0 48px', fontSize: '28px', fontWeight: '900', color: '#1a1a1a' }}>
            ¿Cómo encontrar la propiedad ideal?
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '24px' }}>
            {PASOS.map((paso, i) => (
              <div key={i} style={{
                background: 'white', borderRadius: '16px', padding: '28px 24px',
                boxShadow: '0 4px 16px rgba(0,0,0,0.07)',
                borderTop: '4px solid #007bff',
                display: 'flex', flexDirection: 'column', gap: '12px',
              }}>
                <div style={{ fontSize: '36px', lineHeight: 1 }}>{paso.icono}</div>
                <div style={{
                  width: '26px', height: '26px', borderRadius: '50%',
                  background: '#007bff', color: 'white',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontWeight: '900', fontSize: '13px',
                }}>{i + 1}</div>
                <h3 style={{ margin: 0, fontSize: '17px', fontWeight: '800', color: '#1a1a1a' }}>{paso.titulo}</h3>
                <p style={{ margin: 0, fontSize: '14px', color: '#555', lineHeight: 1.7 }}>{paso.texto}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── VENTAJA CIF ── */}
      <div style={{ background: '#0f2744', padding: '64px 24px' }}>
        <div style={{ maxWidth: '820px', margin: '0 auto', textAlign: 'center' }}>
          <div style={{ fontSize: '52px', marginBottom: '20px', lineHeight: 1 }}>🤝</div>
          <p style={{ margin: '0 0 10px', fontSize: '12px', color: '#60a5fa', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '2px' }}>
            La ventaja de la CIF
          </p>
          <h2 style={{ margin: '0 0 20px', fontSize: '30px', fontWeight: '900', color: 'white', lineHeight: 1.25 }}>
            ¿Tenés un corredor de la CIF de confianza?
          </h2>
          <p style={{ margin: '0 auto 24px', maxWidth: '620px', color: '#93c5fd', fontSize: '16px', lineHeight: 1.8 }}>
            Podés pedirle que te ayude a comprar <strong style={{ color: 'white' }}>cualquier propiedad que veas en FormoProp</strong>,
            aunque esté publicada por otro corredor. Los miembros de la Cámara Inmobiliaria trabajan en conjunto
            para que tu operación sea ágil, segura y con el mejor asesoramiento.
          </p>

          {/* Beneficios */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', margin: '36px 0', textAlign: 'left' }}>
            {[
              { ic: '⚖️', t: 'Seguridad jurídica', d: 'Matriculados y habilitados por el Colegio de Martilleros y Corredores.' },
              { ic: '🔗', t: 'Red de colaboración', d: 'Todos los miembros CIF cooperan entre sí para cerrar la mejor operación para vos.' },
              { ic: '🧭', t: 'Asesoramiento integral', d: 'Tu corredor de confianza te guía desde la búsqueda hasta la escritura.' },
            ].map(({ ic, t, d }) => (
              <div key={t} style={{ background: 'rgba(255,255,255,0.07)', borderRadius: '12px', padding: '20px', border: '1px solid rgba(255,255,255,0.1)' }}>
                <div style={{ fontSize: '26px', marginBottom: '10px' }}>{ic}</div>
                <p style={{ margin: '0 0 6px', fontWeight: '800', color: 'white', fontSize: '15px' }}>{t}</p>
                <p style={{ margin: 0, color: '#94a3b8', fontSize: '13px', lineHeight: 1.6 }}>{d}</p>
              </div>
            ))}
          </div>

          <Link to="/vender" style={{
            display: 'inline-block', padding: '14px 32px',
            background: 'white', color: '#0f2744',
            borderRadius: '8px', textDecoration: 'none',
            fontWeight: '800', fontSize: '15px',
          }}>
            Ver los corredores miembros de la CIF →
          </Link>
        </div>
      </div>

      {/* ── CTA FINAL ── */}
      <div style={{ background: '#f0f7ff', padding: '56px 24px', textAlign: 'center' }}>
        <h2 style={{ margin: '0 0 14px', fontSize: '26px', fontWeight: '900', color: '#1a1a1a' }}>
          ¿Listo para encontrar tu propiedad?
        </h2>
        <p style={{ margin: '0 auto 28px', maxWidth: '440px', color: '#555', fontSize: '15px', lineHeight: 1.7 }}>
          Más de {' '}
          <strong style={{ color: '#007bff' }}>30 corredores matriculados</strong>
          {' '} publican sus propiedades en FormoProp. Explorá el catálogo y encontrá la tuya.
        </p>
        <div style={{ display: 'flex', gap: '14px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/" style={{
            padding: '14px 30px', background: '#007bff', color: 'white',
            borderRadius: '8px', textDecoration: 'none', fontWeight: '800', fontSize: '15px',
          }}>
            🔍 Ir al catálogo
          </Link>
          <Link to="/vender" style={{
            padding: '14px 30px', background: 'white', color: '#007bff',
            border: '2px solid #007bff',
            borderRadius: '8px', textDecoration: 'none', fontWeight: '800', fontSize: '15px',
          }}>
            👔 Ver los corredores
          </Link>
        </div>
      </div>

    </div>
  );
}
